module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "aintro",
      "title": "Introduction"
    }
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#intro"
    }
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagekx"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Communication seems to be easier than ever. There’s no shortage of options, from texting and email to Snapchat, Facebook, and Instagram. But this is the reality: when it comes to digging deeper and getting to the heart and soul of another being, well, we’re pretty out of practice. How often have you sat across from your partner and heard the same old, same old? Or maybe you’re the one asking the superficial and routine questions: How was your day? How do you feel? What do you want for dinner? What should we watch?")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Sound familiar? Maybe too familiar? It’s no wonder most of us have tuned out, and—sadly—sometimes turned off.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("That’s why I’ve written "), _c('i', [_vm._v("808 Conversations Starters for Couples")]), _vm._v(". The questions offered on the following pages will help partners to dig deeper, unlock secrets, reveal passions, engage desires, and ultimately gain trust and intimacy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Just imagine how a relationship can grow by learning something new about the person you’ve known for only a few weeks or for even decades. That’s the power of thought-provoking, open-ended questions. They get us to dig deep, examine our motives, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("review our personal histories, crack our hearts open, and answer with honesty and—if we’re even luckier—revelation.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("But that’s only half the picture. The other place to put your attention is in the arena of listening. You’ll need to be fully present. Nobody wants to speak if the person on the receiving end is distracted, dismissive, or unresponsive. The truth is, listening is as powerful as asking. That’s why before you begin this endeavor, vow to stay receptive and respectful. No answer should be dissed or denied. If you have doubts about the response, allow yourself to follow through, but from a place of curiosity and caring. With this in mind, prepare yourself to reach a new level of trust and loving with your partner. And who doesn’t want that?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-588f6752","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Introduction.vue
// module id = 72
// module chunks = 0